import { ApplicationState, TosUpdatedDatesStatus } from './types';

export const INITIAL_STATE: ApplicationState = {
  tosUpdatedDates: {
    status: TosUpdatedDatesStatus.NotLoaded,
    dates: null,
  },
  tosNextUpdateDates: {
    status: TosUpdatedDatesStatus.NotLoaded,
    dates: null,
  },
  ipAddress: null,
  region: 'au',
  isReady: false,
  firstScrolledToHash: null,
};
